<template>
    <div>
        <h3 class="mt-4" v-if="title">Documentos subidos:</h3>
        <ul class="list-unstyled">
            <template v-for="documento in data.documentos">
                <li :key="documento.id" v-if="!esImagen(documento.ruta_fichero)">
                    <a :href="documento.url" target="_blank" class="btn-link text-secondary"><i class="far fa-fw fa-image"></i> {{ documento.nombre }}</a>
                    <button style="border: 0; background-color: white; margin-right: 1px; padding-right: 1px;" @click="showModal('borrar-' + documento.id)">&#10006;</button>
                    <button style="border: 0; background-color: white; transform: scaleX(-1);" class="m-0 p-0" @click="showModal('editar-' + documento.id)">&#9998;</button>
                    <BorrarModalComponent
                        :name="'borrar-' + documento.id"
                        :title="'Borrar documento ' + documento.nombre"
                        confirmButton="¿Está segur@ de borrar este documento?"
                        v-on:close="() => closeModal()"
                        v-on:confirm="() => borrarDocumento(documento.id)"
                    />
                    <EditDocumento :documento="documento" @close="closeModal()" @confirm="editarDocumento"/>
                </li>
            </template>
        </ul>
        <b-card class="mt-3" v-if="data.documentos && data.documentos.length > 0">
            <b-card-title>Documentación subida</b-card-title><br/><br/>
            <b-card-body class="p-0">
                <b-col cols="12" class="p-0">
                    <b-col class="p-0 text-center">
                        <ul class="list-unstyled d-flex flex-wrap justify-content-center">
                            <template v-for="documento in data.documentos" >
                                <li class="mb-4" :key="documento.id" style="margin: 20px; width: 200px;" v-if="esImagen(documento.ruta_fichero)">
                                    <div class="d-flex flex-column align-items-center">
                                        <img :src="documento.url" class="img-fluid" style="width: 100%; height: auto; cursor: pointer;" @click="mostrarImagenGrande(documento)" />
                                        
                                        <div style="text-align: center; margin-top: 10px; width: 100%;">
                                            <a :href="documento.url" target="_blank" class="btn-link text-secondary" style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 180px;">
                                                <i class="far fa-fw fa-image"></i> {{ documento.nombre }}
                                            </a>
                                            <div class="mt-2">
                                                <button style="border: 0; background-color: white; margin-right: 5px;" @click="showModal('borrar-' + documento.id)">&#10006;</button>
                                                <button style="border: 0; background-color: white; transform: scaleX(-1);" @click="showModal('editar-' + documento.id)">&#9998;</button>
                                            </div>
                                        </div>
                                    </div>

                                    <BorrarModalComponent
                                        :name="'borrar-' + documento.id"
                                        :title="'Borrar documento ' + documento.nombre"
                                        confirmButton="¿Está segur@ de borrar este documento?"
                                        v-on:close="closeModal"
                                        v-on:confirm="() => borrarDocumento(documento.id)"
                                    />
                                    <EditDocumento :documento="documento" @close="closeModal" @confirm="editarDocumento"/>
                                </li>
                            </template>
                        </ul>

                        <b-modal v-model="modalVisible" size="lg" hide-footer title="Vista previa"  >
                            <div style="text-align: center;">
                                <img :src="imagenGrande" alt="Imagen grande" style="width: 100%; height: auto; max-height: 50vh;" />
                            </div>
                        </b-modal>
                    </b-col>
                </b-col>
            </b-card-body>
        </b-card>
        <div class="col-12 col-md-6 col-lg-12">
            <label>Subir documentación</label>
            <Dropzone 
                v-if="url"
                :url="url"
                :maxFiles="50"
                @success="imagenSubida"
                :acceptedFiles="'image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf'"
            />
        </div>
    </div>
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";
    import EditDocumento from "./modals/EditDocumento";
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['data', 'params', 'ruta', 'url' , 'title'],
        data() {
            return {
                modalVisible: false, 
                imagenGrande: '',   
            };
        },
        methods: {
            mostrarImagenGrande(documento) {
                this.imagenGrande = documento.url;
                this.modalVisible = true;
            },
            borrarDocumento(id) {
                this.params.documento_id = id;

                const params = this.params;
                params.lista_id = this.$route.params.lista_id;

                this.$store.dispatch(this.config.getVuexAlias(this.ruta), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.$emit('actualizado');
                }).catch(error => {
                    this.$toast.error('El archivo que intentas borrar no existe');
                });
            },
            editarDocumento(documento) {
                this.$emit('editarDocumento', documento);
            },
            imagenSubida(file, response) {
                this.$emit('actualizado');
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            esImagen(documento) {
                const formatoImagen = /\.(png|jpg|jpeg)$/i;
                return formatoImagen.test(documento);
            }
        },
        components: { BorrarModalComponent, EditDocumento, Dropzone }
    }
</script>